import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useState } from "react";

export const HeroSection = () => {
  const bgImageUrl = '/lovable-uploads/daniel-hero.webp';
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <div className="min-h-screen relative hero-dark overflow-hidden">
      {/* Background image - loads async, fades in once ready */}
      <img
        src={bgImageUrl}
        alt=""
        aria-hidden="true"
        decoding="async"
        loading="eager"
        fetchPriority="high"
        onLoad={() => setImgLoaded(true)}
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
          imgLoaded ? 'opacity-25' : 'opacity-0'
        }`}
      />

      {/* Gradient overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/80" />

      {/* Accent glow */}
      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-[#ffa05d] rounded-full blur-[150px] opacity-20" />
      <div className="absolute bottom-1/4 left-1/4 w-64 h-64 bg-[#A4CBA6] rounded-full blur-[120px] opacity-15" />

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center min-h-screen px-4">
        <div className="max-w-4xl mx-auto text-center fade-in">
          <h1 className="text-4xl md:text-6xl mb-6 text-white font-light tracking-tight">
            Turning ordinary earbuds <br />into health sensors
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-white/70">
            Through the power of cutting-edge artificial intelligence
          </p>
          <Button
            className="text-lg px-8 py-6 bg-[#ffa05d] hover:bg-[#ffa05d]/90 text-white border-0"
            size="lg"
            asChild
          >
            <a href="#tech">Learn More <ArrowRight className="ml-2" /></a>
          </Button>
        </div>
      </div>
    </div>
  );
};
